<section class="our-mission-area ptb-100">
  <div class="container-fluid">
    <div class="row align-items-center">
      <div class="col-lg-6 col-md-12">
        <div class="our-mission-content">
          @for (Content of ourMissionContent; track Content) {
            <div class="content">
              <span class="sub-title"><img src="assets/img/star-icon.png" alt="image"> {{Content.subTitle}}</span>
              <h2>{{Content.title}}</h2>
              <p>{{Content.paragraphText1}}</p>
              <ul class="our-mission-list">
                @for (List of ourMissionList; track List) {
                  <li>
                    <span>
                      <div class="icon">
                        <i class="{{List.icon}}"></i>
                      </div>
                      {{List.title}}
                      <img src="assets/img/our-mission/shape2.png" alt="">
                    </span>
                  </li>
                }
              </ul>
              <p>{{Content.paragraphText2}}</p>
              <a routerLink="/{{Content.defaultBtnLink}}" class="default-btn"><i class="{{Content.defaultBtnIcon}}"></i>{{Content.defaultBtnText}}<span></span></a>
            </div>
          }
        </div>
      </div>
      <div class="col-lg-6 col-md-12">
        @for (Image of ourMissionImage; track Image) {
          <div class="our-mission-image">
            <img [src]="Image.img" alt="Data science and data analysis agency">
            <div class="shape"><img src="assets/img/our-mission/shape1.png" alt=""></div>
          </div>
        }
      </div>
    </div>
  </div>
</section>